var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200.1",
    style: {
      enableBackground: "new 0 0 200 200.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9B0008;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.6,114.9H41.4c-7.8-0.2-14.3,6-14.5,13.8c-0.2,7.8,6,14.3,13.8,14.5c0.3,0,0.5,0,0.8,0h10.1v41.6 c0,8.4,6.8,15.3,15.2,15.3h66.5c8.4,0,15.3-6.9,15.3-15.3v0v-41.6h10.1c7.8-0.2,14-6.7,13.8-14.5 C172.2,121.1,166.1,115.1,158.6,114.9L158.6,114.9z M51.5,137.1H41.4c-4.4,0-8.1-3.6-8.1-8c0-4.4,3.6-8.1,8-8.1c0,0,0,0,0,0h10.1 V137.1z M69.7,193.9h-3c-5.1,0-9.1-4.1-9.2-9.2V121h12.2V193.9z M93.4,193.9H75.7V121h17.6V193.9z M142.4,184.8 c0,5.1-4.1,9.2-9.2,9.2H99.4V121H127v60.4c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0,0,0,0,0-0.1V121h9.4L142.4,184.8z M158.6,137.1 h-10.1V121h10.1c4.4,0,8.1,3.6,8.1,8.1S163,137.1,158.6,137.1L158.6,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114,77.6V17.8C114,8,106,0,96.2,0H17.8C8,0,0,8,0,17.8v59.8c0,9.8,8,17.8,17.8,17.8h78.4 C106,95.4,114,87.4,114,77.6z M6,77.6V17.8C6,11.3,11.3,6,17.8,6h78.4c6.5,0,11.7,5.3,11.7,11.8v59.8c0,6.5-5.2,11.8-11.7,11.8 H17.8C11.3,89.4,6,84.1,6,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.9,153.6c-1.7,0-3,1.3-3.1,2.9c0,0,0,0,0,0.1v24.7c0,1.7,1.4,3,3,3c1.7,0,3-1.4,3-3v-24.8 C115.9,155,114.5,153.6,112.9,153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.9,0h-59.6c-1.7,0-3,1.3-3,3c0,0,0,0,0,0.1v89.3c0,1.7,1.3,3,2.9,3.1c0,0,0,0,0.1,0h59.6 c1.7,0,3-1.3,3.1-2.9c0,0,0-0.1,0-0.1V3.1c0-1.7-1.3-3-2.9-3.1C197,0,197,0,196.9,0z M164.1,89.4h-23.7V65.7h23.7V89.4z  M164.1,59.6h-23.7V35.9h23.7V59.6z M164.1,29.8h-23.7V6h23.7V29.8z M193.9,89.4h-23.7V65.7h23.7L193.9,89.4z M193.9,59.6h-23.7 V35.9h23.7L193.9,59.6z M193.9,29.8h-23.7V6h23.7L193.9,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.6,45.6c-0.6,0.6-0.9,1.4-0.9,2.2c0,0.8,0.4,1.5,0.9,2.1c1.2,1.2,3.1,1.2,4.2,0.1c0,0,0,0,0.1-0.1 c0.6-0.5,0.9-1.3,0.9-2.1c0-0.8-0.3-1.6-0.9-2.2C33.7,44.4,31.8,44.4,30.6,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.9,44.7c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.6,0,3-1.3,3-2.9C52,46.1,50.7,44.7,48.9,44.7 C49,44.7,49,44.7,48.9,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.1,44.7c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.6,0,3-1.3,3-2.9C68.1,46.1,66.8,44.7,65.1,44.7 C65.1,44.7,65.1,44.7,65.1,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.1,45.6c-0.6,0.6-0.9,1.4-0.8,2.2c0,0.8,0.3,1.5,0.8,2.1c0.6,0.6,1.4,0.9,2.2,0.9c0.8,0,1.6-0.3,2.2-0.9 c0.6-0.5,0.9-1.3,0.9-2.1c0-0.8-0.3-1.6-0.9-2.2C82.2,44.4,80.3,44.4,79.1,45.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.8c0ad2981203050d8b6fd48bb3290367.svg";
export { ForwardRef as ReactComponent };